import { useTenantContext } from '@/contexts/TenantContext';

/**
 * Hook to get the active tenant_id (respects tenant switching for super admins)
 */
export function useTenantId() {
  const { activeTenantId, isLoading } = useTenantContext();

  return {
    tenantId: activeTenantId,
    isLoading,
    error: null,
  };
}
